import { FinTechOpsCategories, USER_METRICS_LAST_UPDATED_AT_S3_PREFIX, USER_METRICS_S3_PREFIX } from '../../FinTechOpsConstants';
import { returnUsefulRawUserMetricsData } from '../../user-metrics/utils/userMetricsParsing';
import { UserMetricsParsedDetails, UserMetricsRawData } from '../../user-metrics/UserMetricsInterfaces';
import { useS3Dataset, UseS3DatasetResult } from './useS3Dataset';

export const useUserMetricsData = (): UseS3DatasetResult<UserMetricsParsedDetails> =>
  useS3Dataset<UserMetricsRawData[], UserMetricsParsedDetails>({
    prefix: USER_METRICS_S3_PREFIX,
    lastUpdatedPrefix: USER_METRICS_LAST_UPDATED_AT_S3_PREFIX,
    category: FinTechOpsCategories.userMetrics,
    parse: returnUsefulRawUserMetricsData
  });
